import { Users } from './api/users';
import { Products } from './api/products';
import { ShoppingCart } from './api/shopping_cart';
import { BillingInfo } from './api/billing_info';
import { WishList } from './api/wish_list';
import { States } from './api/states';
import { Search } from './api/search';
import { Orders } from './api/orders';
import { Sliders } from './api/sliders';
import { Categories } from './api/categories';
import { Projects } from './api/projects';
import { PromoCodes } from './api/promo_code';
import { Newsletter } from './api/newsletter';
import { Colors } from './api/colors';
import { Contact } from './api/contact';
import { Selections } from './api/selections';

// export const api_base = 'http://localhost:8000';
// export const api_base = 'http://api.lasddi.agenciaparadoja.com';
export const api_base = 'https://lasddi.com/api';

export default {
	Products,
	ShoppingCart,
	BillingInfo,
	WishList,
	States,
	Search,
	Users,
	Orders,
	Categories,
	Sliders,
	Projects,
	PromoCodes,
	Newsletter,
	Colors,
	Contact,
	Selections
};



// WEBPACK FOOTER //
// ./src/store/api.js